export default __webpack_public_path__ + "static/media/carousel_card_bg.53f2e0de.png";